import { httpGet } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { AchievementBadge } from './types';

/**
 * Retrieves unlocked achievements for user
 *
 * @method getUnlockedAchievements
 * @memberof Gamification
 * @param  {number} page - Page number
 * @returns {Promise<AchievementBadge[]>} - Array of AchievementBadge properties
 */

export const getUnlockedAchievements = async (page: number): Promise<AchievementBadge[]> => {
  const url = `${Constants.BACKEND_URL}/achievements/get-unlocked-achievements/${page}`;

  return httpGet(url, {}).then((response) => {
    if (response && response.data) {
      const unlockedAchievements = response.data.unlocked_achievements;
      const processedBadges = [];

      for (const userAchievement of unlockedAchievements) {
        processedBadges.push({
          title: userAchievement.achievement.name,
          image: `/content/communications/BADGE/${userAchievement.achievement.badge_image}`,
        });
      }

      return processedBadges;
    }
    return [];
  });
};
